import { FaParagraph } from "react-icons/fa";
import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const helpAndSupportPage = {
    mobile: {
        baseWrapper: {
            display: "flex",
            flexDirection: "column" as "column"
        },
        leftWrapper: {
            width: "100vw",
            height: "42.27vw"  
        },
        rightWrapper: { 
            paddingLeft: "4.83vw"        
        },
        searchWrapper: {
            display: "none"
        },
        searchBar: {
            display: "none"
        },
        profileWrapper: {
            display: "flex"
        },
        header: {
            width: "100%"
        },
        title: {
            height: "6.76vw",
            fontSize: "6.03vw",
            color: Color.DeepBlack, 
            fontWeight: "bold" as "bold",
            marginTop: "6.76vw"
        },
        tabs: {
            marginTop: "5.79vw",
            marginLeft: "0.52vw"
        },
        tab: {
            height: "8.45vw",
            fontSize: "3.62vw",
            borderRadius: "6.03vw",
            backgroundColor: Color.LightAsh,
            color: Color.SharpAsh,
            marginRight: "2.41vw",
            padding: "1.93vw  3.38vw 2.41vw 3.62vw", 
            active: {
                backgroundColor: Color.Blue,
                color: Color.White 
            }
        },
        newJob: {
            display: "flex",
            alignItems: "center",
            fontSize: "3.86vw",
            fontWeight: "bold" as "bold",
            color: Color.DeepBlack,
            padding: "0",
            iconWrapper: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "8.21vw",
                width: "8.21vw",
                background: Color.DeepBlack,
                borderRadius: "4.10vw",
                marginLeft: "2.41vw"
            },
            icon: {
                height: "2.90vw",
                width: "2.90vw",
                fill: Color.White
            }
        },
        FAQs: {
            subTitle: {
                color: Color.DeepAsh,
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                marginTop: "5.79vw",
                marginLeft: "3.62vw",
                fontWeight: "bold" as "bold"       
            },
            wrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                marginTop: "1.20vw"
            },
            tabsWrapper: {
                position: "relative" as "relative",
                width: "90.33vw"
            },
            tabs: {
                display: "flex",
                flexDirection: "row" as "row",
                gap: "2.41vw",
                width: "90.33vw",
                marginBottom: "5.56vw",
                overflowX: "auto" as "auto",
                overflowY: "hidden" as "hidden",
                WebkitOverflowScrolling: "touch",
                scrollbarWidth: "none"
            },
            tabButton: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center" as "center",
                justifyContent: "center",
                flex: "0 0 auto",
                width: "auto",
                height: "8.21vw",
                fontSize: "3.86vw",
                fontFamily: Font.Poppins,
                paddingLeft: "3.62vw",
                paddingRight: "3.62vw",
                backgroundColor: Color.White,
                border: "0.10vw solid "+ Color.LightSliverGray,
                borderRadius: "4.10vw",
                marginBottom: "1.20vw",
                color: Color.SharpAsh,
                active: {
                    fontWeight: "500",
                    backgroundColor: Color.DeepBlack,
                    border: "0.10vw solid " + Color.DeepBlack,
                    color: Color.White
                }
            },
            moreTopicsButton: {
                position: "absolute" as "absolute",
                top: "0",
                right: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "8.21vw",
                height: "8.21vw",
                border: "none",
                borderRadius: "50%",
                backgroundColor: Color.DeepBlack,
                color: Color.White,
                fontFamily: Font.Poppins,
                fontSize: "6.10vw",
                fontWeight: "bold" as "bold",
                lineHeight: "1",
                boxShadow: "0 1.45vw 3.62vw rgba(0, 0, 0, 0.35)",
                cursor: "pointer",
                zIndex: 1
            },
            categoryIcon: {
                display: "none",
                active: {
                    fill: Color.Black,
                    width: "3.10vw",
                    height: "3.58vw"
                }
            },         
            activeIcon: {
                display: "none"
            },
            contents: {
                marginTop: "0",
                marginBottom: "1.5vw",
            },
            content: {
                question: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    alignItems: "center" as "center",
                    justifyContent: "space-between",
                    color: Color.DeepAsh,
                    fontSize: "3.80vw",
                    width: "85.33vw",
                    height: "auto",
                    cursor: "pointer",
                    fontFamily: Font.Default,
                    borderRadius: "2.41vw",
                    backgroundColor: Color.LightAsh,
                    marginBottom: "2.41vw",
                    border: "0.10vw solid " + Color.LightSliverGray,
                    overflow: "hidden" as "hidden",
                    lineHeight: "4vw",
                    padding: "1.50vw 1.25vw 1.50vw 4.10vw",
                    fontWeight: "bold" as "bold",
                    active: {
                        backgroundColor: Color.DeepBlack,
                        color: Color.White,
                        fontWeight: "bold" as "bold"
                    }
                },
                text: {
                    fontSize: "3.86vw",
                    color: Color.GraniteGray,
                    fontWeight: "bold" as "bold",
                    marginLeft: "4.10vw",
                    paddingTop: "2.65vw",
                    width: "76.32vw",
                    fontFamily: Font.Poppins,
                    active:{
                        color: Color.White
                    }
                },
                dropdownIcon: {
                    width: "4.17vw",
                    height: "4.58vw",
                    fill: Color.GraniteGray,
                    marginRight: "3.00vw",
                    marginLeft: "3.50vw",
                    marginTop: "1.65vw",
                    transition: "transform .3s ease-in-out",
                    active: {
                        transform: "rotate(180deg)",
                        fill: Color.White
                    }
                },
                answer: {
                    width: "81.40vw",
                    fontSize: "3.62vw",
                    lineHeight: "5.5vw",
                    fontWeight: "500",
                    padding: "4.83vw 0 7.24vw 4.83vw",
                    fontFamily: Font.Poppins,
                    color: Color.MiddleBlack,
                    maxHeight: "0",
                    overflow: "hidden",
                    transition: "max-height 0.5s ease, padding 0.5s ease",
                    active: {
                        maxHeight: "500px",
                        padding: "4.83vw 0 7.24vw 4.83vw",
                    },
                    inactive: {
                        maxHeight: "0",
                        padding: "0 0 0 1.56vw",
                    }
                },
                paragraph: {
                    margin: '0 0 1vw 0',
                    fontFamily: Font.Poppins
                }
            }
        },
        contactUs: {
            formWrapper: {
                width: "90.33vw",
                marginRight: "4.83vw",
                marginTop: "9.66vw"
            },
            formLabel: {
                height: "1.30vw",
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                marginLeft: "3.62vw",
                fontFamily: Font.Poppins
            },
            inputWrapper: {
                width: "90.33vw",
                height: "12.07vw",
                marginBottom: "10.43vw",
                position: "relative"
            },
            selectedWrapper: {
                display: "flex",
                alignItems: "center" as "center",
                width: "90.33vw",
                height: "12.07vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "1.20vw",
                marginTop: "1.2vw",
                zIndex: "3",
                text: {
                    width: "78.98vw",
                    fontSize: "3.62vw",
                    color: Color.SharpAsh,
                    marginLeft: "3.62vw"
                },
                icon: {
                    width: "3.10vw",
                    height: "3.58vw",
                    fill: Color.Black,
                    hover: {
                        transform: "rotate(180deg)"
                    }
                },
                hover: {
                    backgroundColor: Color.White,
                    border: "1px solid" + Color.SharpAsh,
                    borderRadius: "0.52vw 0.52vw 0 0"
                },
                valid: {
                    backgroundColor: Color.LightBlue,
                    border: "1px solid " + Color.Blue
                }
            }, 
            dropdownItems: {
                leave: {
                    display: "none"
                },
                hover: {
                    display: "block",
                    width: "calc(100% - 4.83vw)",
                    WebkitOverflowScrolling: "touch",
                    padding: "0 2.41vw 1.35vh",
                    left: "0",
                    backgroundColor: Color.White,
                    borderRadius: "0 0 1.35vh 1.35vh",
                    border: "1px solid " + Color.LightSilver, 
                    zIndex: "10",
                    position: "absolute"
                }    
            },
            dropdownItem: {
                fontSize: "3.86vw",
                color: Color.SharpAsh,
                display: "block",
                width: "calc(100% - 4.83vw)",
                WebkitOverflowScrolling: "touch",
                padding: "1.25vw 2.41vw 1.25vw 1.35vh",
                left: "0",
                borderBottom: "1px solid " + Color.LightSilver,
                marginTop: "1.00vw",
                hover: {
                    borderRadius: "1.72vw",
                    backgroundColor: Color.LightSilver,
                    cursor: "pointer",
                    fontWeight: "bold" as "bold",
                    color: Color.Black
                }
            },
            label: {
                display: "block",
                border: 0,
                height: "1px",
                width: "100%",
                background: Color.Ash,
                margin: "0 auto",
                zIndex: "1"
            },
            submitButton: {
                 width: "90.33vw",
                 height: "12.07vw",
                 borderRadius: "2.41vw",
                 backgroundColor: Color.Green,
                 boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                 marginTop: "7.24vw",
                 marginBottom: "10.46vw",
                 fontSize: "4.34vw",
                 fontWeight: "bold" as "bold",
                 color: Color.White
            },
            attachment: {
                display: "flex",
                flexDirection: "row" as "row",
                paddingBottom: " 4.95vw",
                marginTop: "1.20vw",
                fileIcon: {
                    margin: "1.50vw 1.93vw 0 auto"
                },
                valid: {
                    backgroundColor: Color.LightBlue,
                    border: "1px solid " + Color.Blue
                }
            },
            textInput: {
                marginTop: "1.20vw"
            },
            textAreaInput: {
                marginTop: "0.52vw"
            }     
        }
    },
    desktop: {
        baseWrapper: {
            flexDirection: "row" as "row",
            marginTop: "1.56vw"
        },
        leftWrapper: {
            display: "block",
            width: "19.27vw",
            height: "53.12vw",
            marginLeft: "1.56vw"
        },
        rightWrapper: {
            paddingLeft: "2.5vw"
        },
        profileWrapper: {
            marginLeft: "auto"
        },
        header: {
            width : "75.10vw",
            height: "5.72vw"
        },
        title: {
            height: "2.91vw",
            fontSize: "2.60vw",
            marginTop: "0vw",
            marginLeft: "0vw"
        },
        tabs: {
            marginTop: "1.56vw"
        },
        tab: {
            height: "1.82vw",
            fontSize: "0.93vw",
            borderRadius: "1.30vw",
            marginRight: "0.52vw",
            fontWeight: "500",
            padding: "0.36vw 1.04vw 0.36vw 1.04vw"
        },
        newJob: {
            display: "none"
        },
        FAQs: {
            subTitle:{
                fontSize: "1.041vw",
                fontWeight: "bold",
                marginTop: "2.08vw",
                marginLeft: "0.52vw",
                fontFamily: Font.Default,
                color: Color.SharpAsh
            },
            wrapper: {
                flexDirection: "row" as "row",
                marginTop: "0.625vw"
            },
            tabs: {
                display: "flex",
                flexDirection: "column" as "column",
                gap: "0",
                width: "auto",
                marginBottom: "0vw",
                overflowX: "visible" as "visible",
                overflowY: "visible" as "visible",
                scrollbarWidth: "auto"
            },
            tabButton: {
                justifyContent: "space-between",
                flex: "unset",
                width: "13.90vw",
                fontFamily: Font.Default,
                paddingLeft: "0.74vw",
                paddingRight: "0.74vw",
                fontSize: "1.04vw",
                height: "2.34vw",
                backgroundColor: Color.White,
                border: "0.10vw solid "+ Color.LightSliverGray,
                borderRadius: "0.52vw",
                marginBottom: "0.52vw",
                fontWeight: "500"
            },
            categoryIcon:{ 
                display: "none",
                width: "0.66vw",
                height: "1.00vw"
            },
            activeIcon: {
                display: "block",
                fill: Color.Black,
                transform: "rotate(270deg)"
            },
            contents: {
                marginTop: "",
                marginBottom: "",
                marginLeft: "2.08vw"
            },
            content: {
                question: {
                    fontSize: "1.04vw",
                    fontFamily: Font.Poppins,
                    color: Color.SharpAsh,
                    flexDirection: "row" as "row",
                    width: "54.11vw",
                    borderRadius: "0.78vw",
                    border: "none",
                    marginBottom: "0.52vw",
                    paddingLeft: "1.56vw",
                    fontWeight: "bold" as "bold",
                    lineHeight: "1.3",
                    padding: "1.25vw 1.25vw 1.25vw 4.10vw"                    
                },
                dropdownIcon: {
                    width: "0.81vw",
                    height: "0.46vw",
                    marginLeft: "1vw",
                    marginTop: "0.45vw"
                },
                iconWrapper: {
                    width: "2.5vw"
                },
                answer: {
                    width: "52.98vw",
                    fontSize: "0.93vw",
                    lineHeight: "1.5vw",
                    fontWeight: "500",
                    padding: "0 0 0 1.56vw",
                    color: Color.SharpAsh,
                    margin: "0",
                    maxHeight: "0",
                    overflow: "hidden",
                    transition: "max-height 0.5s ease, padding 0.5s ease",
                    active: {
                        maxHeight: "250px",
                        padding: "1.82vw 0 2.60vw 1.56vw"
                    },
                    inactive: {
                        maxHeight: "0",
                        padding: "0 0 0 1.56vw",
                    }
                },
                paragraph: {
                    margin: '0 0 0.41vw 0'
                }
            }
        },
        contactUs: {
            formWrapper: {
                width: "42.23vw",
                marginLeft: "12.70vw",
                marginTop: "2.18vw" 
            },
            formLabel: {
                height: "1.30vw",
                fontSize: "0.93vw",
                marginLeft: "0.52vw"
            },
            inputWrapper: {
                display: "flex",
                flexDirection: "column" as "columnn",
                width: "42.23vw",
                height: "5.46vw",
                marginBottom: "1.04vw"
            },
            selectedWrapper: {
                width: "42.23vw",
                height: "3.64vw",
                borderRadius: "0.52vw",
                marginTop: "0.52vw",
                text: {
                    display: "flex",
                    alignItems: "center" as "center",
                    width: "38.22vw",
                    marginLeft: "1.56vw",
                    fontSize: "0.93vw",
                    height: "3.64vw"
                },
                icon: {
                    width: "0.78vw",
                    height: "0.88vw",
                    fill: Color.GraniteGray
                },
                hover: {
                    borderRadius: "0.52vw 0.52vw 0 0"
                }
            },
            dropdownItems: {
                hover: {
                    width: "calc(100% - 3.0vw)",
                    WebkitOverflowScrolling: "touch",
                    padding: "0 1.5vw 1.35vh 1.5vw",
                    left: "0",
                    borderRadius: "0 0 1.35vh 1.35vh",
                    marginTop: "5.2vw",
                    zIndex: "2" 
                }    
            },
            dropdownItem: {
                fontSize: "0.93vw",
                WebkitOverflowScrolling: "touch",
                marginTop: "0.52vw",
                width: "92%",
                height: "1.00vw", 
                padding: "0.94vw 2.41vw 0.5vw 1.35vh",
                left: "0",
                backgroundColor: Color.White,
                hover: {
                    borderRadius: "0.52vw"
                }
            },
            label: {
                height: "1px",
                width: "100%",
                margin: "0 auto"
            },
            submitButton: {
                 width: "20.78vw",
                 height: "3.64vw",
                 borderRadius: "0.52vw",
                 boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                 marginTop: "1.56vw",
                 marginBottom: "10.46vw",
                 fontSize: "1.04vw"
            },
            buttonText: {
                fontSize: "1.04",
                fontWeight: "bold" as "bold",
                color: Color.White
            },
            attachment: {
                paddingBottom: " 1.19vw",
                marginTop: "0.52vw",
                fileIcon: {
                    width: "0.84vw",
                    height: "0.84vw",
                    margin: "0.50vw 0.95vw 0 auto"
                }
            },
            textInput: {
                marginTop: "0.52vw"
            },
            textAreaInput: {
                marginTop: "0.52vw"
            }     
        },
        searchWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            height: "4.68vw"
        },
        searchBar: {
            display: "flex",
            alignItems: 'center',
            position: 'relative',
            backgroundColor: Color.Cultured,
            marginTop: "0.52vw",
            marginBottom: "1.56vw",
            width: "25.21vw",
            borderRadius: "0.52vw",
            height: "2.6vw",
            input: {
                border: "none",
                backgroundColor: Color.Cultured,
                width: "21vw",
                paddingLeft: "1.04vw"
            },
            icon: {
                position: "absolute" as "absolute",
                fill: Color.SharpAsh,
                width: "1.14vw",
                height: "1.25vw",
                left: '23.06vw',
                cursor: "pointer"
            }
        }
    }
}
